{getIdsAsList, get_from_list} = require('../../utils')

module.exports = {
  project: ($stateParams, Api) ->
    return Api.Project.get({id: $stateParams.projectId}).$promise

  workflows: ($stateParams, Api) ->
    return Api.Workflow.query({project: $stateParams.projectId}).$promise

  allWorkflowSteps: ($stateParams, Api) ->
    return Api.WorkflowStep.query({project: $stateParams.projectId}).$promise

  starredDocs: ($stateParams, Api) ->
    return Api.ProjectStarredDocument.query({project: $stateParams.projectId}).$promise

  countries: (Api) ->
    return Api.Country.query().$promise

  adverseTermsLists: ($stateParams, Api) ->
    Api.AdverseTerms.query({get_all_versions: "true", project: $stateParams.projectId}).$promise

  searchTermTypes: (Api) ->
    Api.SearchTermTypes.query().$promise

  manualSteps: ($stateParams, Api) ->
    return Api.ManualWorkflowStepIteration.query({project: $stateParams.projectId}).$promise

  states: (Api, project) ->
    return Api.State.query({process: project.process}).$promise

  projectPermissions: (user, project) ->
    user.projectPermissions(project)
}
